import React, { useEffect, useState } from 'react';
import { round  } from '../makeitwork/weather'; 
import rise from'../svg/sunrise.svg';
import set from'../svg/sunset.svg';
/*import {
  UilTemperature,
  UilTear,
  UilWind,
  UilSun,
  UilSunset,
  UilArrowUp,
  UilArrowDown,
} from "@iconscout/react-unicons";*/
function Details({h, currentFormattedData ,temperatureUnit}) {
  const [icons, setIcons] = useState([]);
  useEffect(() => {
  const theicon = {
    night113: "falling-stars",
    night116: "partly-cloudy-night",
    night119: "overcast-night",
    night122: "overcast",
    night143: "partly-cloudy-night-fog",
    night176: "overcast-night-rain",
    night179: "overcast-night-snow",
    night182: "overcast-night-sleet",
    night185: "overcast-fog",
    night200: "thunderstorms-night-extreme",
    night227: "sleet",
    night230: "overcast-snow",
    night248: "partly-cloudy-night-fog",
    night260: "partly-cloudy-night-haze",
    night263: "overcast-night-drizzle",
    night266: "overcast-night-drizzle",
    night281: "overcast-haze",
    night284: "overcast-fog",
    night293: "overcast-night-rain",
    night296: "overcast-rain",
    night299: "overcast-night-rain",
    night302: "overcast-rain",
    night305: "overcast-night-rain",
    night308: "overcast-rain",
    night311: "overcast-haze",
    night314: "overcast-haze",
    night317: "overcast-sleet",
    night320: "overcast-sleet",
    night323: "overcast-night-sleet",
    night326: "overcast-snow",
    night329: "overcast-night-sleet",
    night332: "overcast-snow",
    night335: "overcast-night-sleet",
    night338: "overcast-snow",
    night350: "overcast-smoke",
    night353: "overcast-night-rain",
    night356: "overcast-night-rain",
    night359: "extreme-night-rain",
    night362: "overcast-night-sleet",
    night365: "overcast-night-sleet",
    night368: "overcast-snow",
    night371: "overcast-snow",
    night374: "overcast-smoke",
    night377: "overcast-smoke",
    night386: "thunderstorms-night-extreme",
    night389: "thunderstorms-extreme",
    night392: "thunderstorms-night-extreme-snow",
    night395: "thunderstorms-extreme-snow",
    //day
    day113: "clear-day",
    day116: "partly-cloudy-day",
    day119: "overcast-day",
    day122: "overcast",
    day143: "partly-cloudy-day-fog",
    day176: "overcast-day-rain",
    day179: "overcast-day-snow",
    day182: "overcast-day-sleet",
    day185: "overcast-fog",
    day200: "thunderstorms-day-extreme",
    day227: "sleet",
    day230: "overcast-snow",
    day248: "partly-cloudy-day-fog",
    day260: "partly-cloudy-day-haze",
    day263: "overcast-day-drizzle",
    day266: "overcast-day-drizzle",
    day281: "overcast-haze",
    day284: "overcast-fog",
    day293: "overcast-day-rain",
    day296: "overcast-rain",
    day299: "overcast-day-rain",
    day302: "overcast-rain",
    day305: "overcast-day-rain",
    day308: "overcast-rain",
    day311: "overcast-haze",
    day314: "overcast-haze",
    day317: "overcast-sleet",
    day320: "overcast-sleet",
    day323: "overcast-day-sleet",
    day326: "overcast-snow",
    day329: "overcast-day-sleet",
    day332: "overcast-snow",
    day335: "overcast-day-sleet",
    day338: "overcast-snow",
    day350: "overcast-smoke",
    day353: "overcast-day-rain",
    day356: "overcast-day-rain",
    day359: "extreme-day-rain",
    day362: "overcast-day-sleet",
    day365: "overcast-day-sleet",
    day368: "overcast-snow",
    day371: "overcast-snow",
    day374: "overcast-smoke",
    day377: "overcast-smoke",
    day386: "thunderstorms-day-extreme",
    day389: "thunderstorms-extreme",
    day392: "thunderstorms-day-extreme-snow",
    day395: "thunderstorms-extreme-snow",
  };  
   // Map through each hourItem and load SVG icons dynamically
   const iconsPromises = currentFormattedData.forecast.forecastday[0].hour.map((hourItem) => {
    const currentIcon = hourItem.condition.icon.split('/').slice(-2).join('').replace('.png', '');
    const iconSrc = theicon[currentIcon];
    return import(`../svg/${iconSrc}.svg`).then((module) => module.default);
  });

  // Concatenate the second day's icons to the promises array
  iconsPromises.push(
    ...currentFormattedData.forecast.forecastday[1].hour.map((hourItem) => {
      const currentIcon = hourItem.condition.icon.split('/').slice(-2).join('').replace('.png', '');
      return import(`../svg/${theicon[currentIcon]}.svg`).then((module) => module.default);
    })
  );

  Promise.all(iconsPromises)
    .then((loadedIcons) => setIcons(loadedIcons))
    .catch((error) => console.error(`Failed to load SVG icons: ${error.message}`));
}, [currentFormattedData.forecast.forecastday]);

const todaySunrise = currentFormattedData.forecast.forecastday[0].astro.sunrise.slice(0, 2)+ currentFormattedData.forecast.forecastday[0].astro.sunrise.slice(5, 8);
const todaySunset = currentFormattedData.forecast.forecastday[0].astro.sunset.slice(0, 2)+currentFormattedData.forecast.forecastday[0].astro.sunset.slice(5, 8);
const tomSunrise = currentFormattedData.forecast.forecastday[1].astro.sunrise.slice(0, 2)+ currentFormattedData.forecast.forecastday[1].astro.sunrise.slice(5, 8);
const tomSunset = currentFormattedData.forecast.forecastday[1].astro.sunset.slice(0, 2)+currentFormattedData.forecast.forecastday[1].astro.sunset.slice(5, 8)

  return (
    <div className='mx-3'>
      <div className="flex items-center justify-stat mt-6">
        <p className="text-white font-medium uppercase">{h}</p>
      </div>
      <hr className="my-2"></hr>
      <div className="flex flex-row items-center justify-start text-white details-scroll-container overflow-x-auto relative">
          {currentFormattedData.forecast.forecastday[0].hour.map((weatherItem, index) => {
              const localTime = new Date(currentFormattedData.location.localtime);
              const hourTime = new Date(weatherItem.time).getTime() / 1000;
              const hourString = new Date(weatherItem.time).toLocaleTimeString('en-US', { hour: '2-digit', hour12: true });

              // Only render future hours
              if (hourTime > localTime.getTime() / 1000) {
                  return (
                      <React.Fragment key={index}>
                          {/* Render hourly forecast */}
                          <div
                           key={`forecast-${index}`}
                              className="flex flex-col items-center justify-center mx-2 px-1"
                              style={{ backgroundColor: 'rgb(255, 255, 255, 0.2)', borderRadius: '8px' }}
                          >
                              <p className="font-light text-sm px-9">
                                  {hourString}
                              </p>
                              <img src={icons[index]} alt="Weather Icon" />
                              <p className="font-medium flex flex-row">
                                  {temperatureUnit === 'Celsius' ? round(weatherItem.temp_c) : round(weatherItem.temp_f)}°
                              </p>
                          </div>
                          {/* Render sunrise/set information */}
                          {hourString === todaySunrise || hourString === todaySunset ? (
                              <div
                                key={`sunrise-set-${index}`}
                                className="flex flex-col  items-center justify-center px-8"
                                >
                              <p className="font-light text-sm -mb-5 px-9">
                                  {hourString === tomSunrise ? currentFormattedData.forecast.forecastday[0].astro.sunrise : currentFormattedData.forecast.forecastday[0].astro.sunset} 
                              </p>
                              <img src={hourString === tomSunrise ? rise : set} alt="sun Icon" className=''/>
                              <p className='-mt-8'>{hourString === todaySunrise ? "Sunrise" : "Sunset"}</p>
                          </div>
                          ) : null}
                      </React.Fragment>
                  );
              }

              return null;
          })}

          {currentFormattedData.forecast.forecastday[1].hour.map((weatherItem, index) => {
              const localTime = new Date(currentFormattedData.location.localtime);
              const hourTime = new Date(weatherItem.time).getTime() / 1000;
              const hourString = new Date(weatherItem.time).toLocaleTimeString('en-US', { hour: '2-digit', hour12: true });

              // Only render from 00:00 to local hour time
              if (hourTime < (localTime.getTime() / 1000 + 86400)) {
                  return (
                      <React.Fragment key={index}>
                          {/* Render hourly forecast */}
                          <div
                           key={`forecast-${index}`}
                              className="flex flex-col items-center justify-center mx-2 px-1"
                              style={{ backgroundColor: 'rgb(255, 255, 255, 0.2)', borderRadius: '8px' }}
                          >
                              <p className="font-light text-sm px-9">
                                  {hourString}
                              </p>
                              <img src={icons[index]} alt="Weather Icon" />
                              <p className="font-medium flex flex-row">
                                  {temperatureUnit === 'Celsius' ? round(weatherItem.temp_c) : round(weatherItem.temp_f)}°
                              </p>
                          </div>
                          {/* Render sunrise/set information */}
                          {hourString === tomSunrise || hourString === tomSunset ? (
                              <div
                                  key={`sunrise-set-${index}`}
                                  className="flex flex-col  items-center justify-center px-8"
                              >
                                  <p className="font-light text-sm -mb-5 px-9">
                                      {hourString === tomSunrise ? currentFormattedData.forecast.forecastday[1].astro.sunrise : currentFormattedData.forecast.forecastday[1].astro.sunset} 
                                  </p>
                                  <img src={hourString === tomSunrise ? rise : set} alt="sun Icon"/>
                                  <p className='-mt-8'> {hourString === todaySunrise ? "Sunrise" : "Sunset"} </p>
                              </div>
                          ) : null}
                      </React.Fragment>
                  );
              }

              return null;
          })}
      </div>
    </div>
  );
}  
export default Details;
    